export const scanZh = {
  // 页面标题
  title: '库存扫码',
  subtitle: '扫描零件二维码进行签入签出操作',
  checkInTitle: '扫码入库',
  checkOutTitle: '扫码出库',
  
  // 扫码区域
  scanArea: '扫码区域',
  cameraMode: '摄像头扫码',
  manualMode: '手动输入',
  enterQRCode: '请输入二维码',
  scanButton: '扫描',
  scanning: '扫描中...',
  cameraPlaceholder: '摄像头扫码功能开发中',
  cameraHint: '当前版本请使用手动输入模式',
  
  // 操作
  startScanning: '开始扫描',
  stopScanning: '停止扫描',
  scanCodePrompt: '请扫描条码',
  confirmOperation: '确认操作',
  
  // 信息显示
  partInfo: '零件信息',
  operationDetails: '操作详情',
  noPartScanned: '尚未扫描零件',
  scanOrEnterCode: '请扫描或输入零件二维码',
  
  // 提示消息
  emptyCode: '请输入二维码',
  scanSuccess: '扫描成功',
  scanFailed: '扫描失败，未找到该零件',
  checkPermissions: '请检查摄像头权限',
};

export type ScanTranslations = typeof scanZh;

